export const METERS_PER_SECOND_TO_KNOTS_RATIO = 1.943845249222;
